import { ImageXScopedData } from '@wix/thunderbolt-components-native'
import { SingleLayoutData } from '@wix/document-services-types'
import { BpToDimensions } from '../types/becky'
import { AnimationDef } from '@wix/thunderbolt-becky-types'

const getScopedDataForBp = (
	breakpointsToScopedData: Record<string, Array<ImageXScopedData & { breakpoint: string }>>,
	breakpoints: Array<string>
) => {
	const breakpointWithScopedData: string | undefined = breakpoints.find((bp) => breakpointsToScopedData[bp])
	if (!breakpointWithScopedData && breakpointWithScopedData !== '') {
		return null
	}
	return breakpointsToScopedData[breakpointWithScopedData]
}

const getLayoutForBp = (
	layout: Record<string, SingleLayoutData>,
	breakpoints: Array<string>,
	resolvedLayout: BpToDimensions
) => {
	const currentBreakpoint = breakpoints[0].replace('#', '')
	const breakpointWithData: string | undefined = breakpoints.find(
		(bp) => Object.keys(layout[bp]?.componentLayout || {}).length !== 0
	)
	if (!breakpointWithData && breakpointWithData !== '') {
		return {}
	}

	return {
		...layout[breakpointWithData]?.componentLayout,
		...(resolvedLayout[currentBreakpoint] && {
			resolvedHeight: resolvedLayout[currentBreakpoint].height,
			resolvedWidth: resolvedLayout[currentBreakpoint].width,
		}),
	}
}

export const getResponsiveImageInfoPerBreakpoint = (
	breakpoints: Array<string>,
	scopedData: any,
	layout: Record<string, SingleLayoutData>,
	resolvedLayout: BpToDimensions
) => {
	const breakpointsToScopedData = Object.fromEntries(
		scopedData.map((entry: ImageXScopedData & { breakpoint: string }) => {
			const { breakpoint, ...breakpointScopedData } = entry
			const entryBreakpoint = breakpoint?.replace('#', '') || ''
			return [entryBreakpoint, breakpointScopedData]
		})
	)
	return breakpoints.map((bp, index) => {
		const reversedBreakpoints = breakpoints.slice(0, index + 1).reverse()
		return {
			bp,
			scopedData: getScopedDataForBp(breakpointsToScopedData, reversedBreakpoints),
			layout: getLayoutForBp(layout, reversedBreakpoints, resolvedLayout),
		}
	})
}

export const getAllImageXScrubAnimations = (
	activeAnimations: {
		[compId: string]: Array<AnimationDef>
	} = {},
	imageXAnimations: Array<Record<string, Array<AnimationDef>>>
) => {
	const allCompAnimations = { ...activeAnimations }
	imageXAnimations.forEach((animationType: Record<string, Array<AnimationDef>>) =>
		Object.entries(animationType).forEach(([compId, animations]) => {
			if (!allCompAnimations[compId]) {
				allCompAnimations[compId] = []
			}
			allCompAnimations[compId].push(...animations)
		})
	)
	return allCompAnimations
}

export const getBreakpointsToExcludeWithDefault = (scopedDataWithMinMax: any, scrollEffectName: string) => {
	const lowerBoundForExclusion = scopedDataWithMinMax.find((datum: any) => datum?.scrollEffect === scrollEffectName)
		?.minMax?.max
	const defaultHasEffect = scopedDataWithMinMax.find((datum: any) => !datum.breakpoint && datum?.scrollEffect)
	const scopedDataWithMinMaxWithDefaultPlaceholder = !defaultHasEffect
		? [{}, ...scopedDataWithMinMax]
		: scopedDataWithMinMax
	const entriesToExclude = scopedDataWithMinMaxWithDefaultPlaceholder.filter(
		(datum: any) => !datum?.scrollEffect || datum.scrollEffect !== scrollEffectName
	)
	return entriesToExclude.map((datum: any) => datum?.minMax || { min: lowerBoundForExclusion })
}
